export default __webpack_public_path__ + "static/media/DeployingBoom.6286a59d.png";